import { defineStore } from 'pinia'
import { api } from '@/plugins/api'
import { authStore } from './auth'

export const lookupStore = defineStore('lookup', {
  state: () => ({
    lookups: {},
    userRoles: [],
    loading: {
      lookups: false,
      userRoles: false
    }
  }),
  actions: {
    async getLookups(data) {
      const store = authStore()
      let _lookups = {}
      let _keys = data.keys.filter((k) => !this.lookups[k])
      let reset = false
      if (data.refresh) {
        reset = data.refresh
      }
      if (_keys.length || reset) {
        this.loading.lookups = true
        let results = await api.post(`lookup/byKeys`, {
          app: data.app ? data.app : null,
          keys: data.keys,
          firm: data.firm ? parseInt(data.firm) : parseInt(store.profile.firm),
          showInactive: false
        })
        this.loading.lookups = false
        if (results) {
          for (let key of data.keys) {
            _lookups[key] = []
            for (let item of results) {
              if (item.key.toLowerCase() === key.toLowerCase()) {
                item.codename = item.name
                item.name = item.value || item.name
                item.value = item.id || item.value
                item.isInactive = false
                _lookups[key].push(item)
              }
            }
          }
          this.lookups = JSON.parse(JSON.stringify(Object.assign(this.lookups, _lookups)))
        }
      }
      console.log('Got Lookups', this.lookups)
      return this.lookups
    },
    async getRoles(firm) {
      this.userRoles = []
      this.loading.userRoles = true
      let roles = await api.get(`lookup/roles?firm=${firm}`)
      if (roles) {
        roles.forEach((role) => {
          this.userRoles.push({
            id: role.role,
            value: role.role,
            name: role.name,
            description: role.description
          })
        })
      }
      console.log('Got Roles', this.userRoles)
      this.loading.userRoles = false
      return this.userRoles
    },
    async upsertLookup(data) {
      return await api.post('lookup/upsert', data)
    },
    async getCountryCode(id) {
      let code = null
      this.lookups['Country'].forEach((element) => {
        if (parseInt(element.value) === parseInt(id)) {
          code = element.code
        }
      })
      return code
    },
    async getStateProvinceAbbr(id) {
      let abbr = null
      this.lookups['StateProvince'].forEach((element) => {
        if (parseInt(element.value) === parseInt(id)) {
          abbr = element.name
        }
      })
      return abbr
    }
  }
})
